/* Selden v70 — short gallery and short reviews on product pages. Theme-only. */
(function () {
  var isProduct = document.body.classList.contains('sd-tpl-product');
  if (!isProduct) return;

  /* K1 — keep the first 5 visible photos, hide the rest behind "See all N photos" (desktop only, via CSS) */
  function shortGallery() {
    document.querySelectorAll('.shopify-section--main-product product-gallery').forEach(function (g) {
      if (g.dataset.sdOpen === '1') return;
      var visible = Array.prototype.filter.call(g.querySelectorAll('.product-gallery__media'), function (m) { return !m.hidden; });
      if (visible.length <= 6) return;
      visible.forEach(function (m, i) { m.classList.toggle('sd-gal-extra', i >= 5); });
      g.classList.add('sd-gal-short');
      var btn = g.querySelector('.sd-gal-more');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sd-gal-more';
        btn.addEventListener('click', function () {
          g.dataset.sdOpen = '1';
          g.classList.remove('sd-gal-short');
          btn.remove();
        });
        (g.querySelector('.product-gallery__image-list') || g).appendChild(btn);
      }
      btn.textContent = 'See all ' + visible.length + ' photos';
    });
  }

  /* K3 — Trustoo list: first 3 distinct reviews, then a button to show them all */
  function shortReviews() {
    var list = document.querySelector('.tt-review-list');
    if (!list || list.dataset.sdDone) return false;
    var items = list.querySelectorAll(':scope > .list-review');
    if (!items.length) return false;
    list.dataset.sdDone = '1';
    var seen = {}, shown = 0;
    items.forEach(function (it) {
      var key = (it.textContent || '').replace(/\s+/g, ' ').replace(/^.*?ago/, '').trim().slice(0, 160);
      var dup = seen[key];
      seen[key] = true;
      if (!dup && shown < 3) { shown++; } else { it.classList.add('sd-rev-extra'); }
    });
    var wrap = list.closest('.trustoo-widget') || list.parentElement;
    wrap.classList.add('sd-rev-short');
    var m = (wrap.innerText || '').match(/(\d+)\s+reviews/i);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sd-rev-more';
    btn.textContent = m ? 'Read all ' + m[1] + ' reviews' : 'Read all reviews';
    btn.addEventListener('click', function () { wrap.classList.remove('sd-rev-short'); btn.remove(); });
    list.insertAdjacentElement('afterend', btn);
    return true;
  }

  function init() {
    shortGallery();
    var tries = 0;
    (function poll() { if (shortReviews() || ++tries > 40) return; setTimeout(poll, 500); })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('variant:change', function () { setTimeout(shortGallery, 60); });
})();

/* 2026-10-19 — product pages: italic last word in titles, roman numerals on the sections below the buy box, reviews heading */
(function () {
  if (!document.body || !document.body.classList.contains('sd-tpl-product')) return;
  var ROMAN = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'];
  function italicLast(el) {
    if (!el || el.dataset.sdIt || el.children.length) return;
    var t = el.textContent.trim(), i = t.lastIndexOf(' ');
    if (i < 1) return;
    el.dataset.sdIt = '1';
    el.textContent = t.slice(0, i + 1);
    var em = document.createElement('i'); em.textContent = t.slice(i + 1); el.appendChild(em);
  }
  function handle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0].split('/products/')[1] : '';
  }
  /* v74: product rows without duplicates; a row with fewer than 3 products is hidden (v95, was 4) */
  function rows() {
    var me = (location.pathname.split('/products/')[1] || '').split('/')[0], seen = {};
    seen[me] = true;
    document.querySelectorAll('main .shopify-section--featured-collections, main .shopify-section--related-products').forEach(function (sec) {
      if (/__featured_collections_pp_2$/.test(sec.id)) return;
      /* v95: the "More …" row + FAQ section fills its own row in Liquid (never under 4); hiding it also hid the FAQ */
      if (/__sd_r41_pdp_more$/.test(sec.id)) return;
      var cards = sec.querySelectorAll('product-card');
      if (!cards.length) return;
      var vis = [];
      cards.forEach(function (c) { var h = handle(c); if (h && seen[h]) c.style.display = 'none'; else vis.push(h); });
      /* v95: 3 is enough (the Outdoor collection has only 4 lights, so its "You may also like" shows 3) */
      if (vis.length < 3) { sec.style.display = 'none'; return; }
      sec.style.display = '';
      vis.forEach(function (h) { seen[h] = true; });
    });
  }
  /* v74: Description gets a line icon like the other panels */
  function descIcon() {
    document.querySelectorAll('.shopify-section--main-product .accordion__toggle .text-with-icon').forEach(function (t) {
      if (t.querySelector('svg') || !/^\s*description\s*$/i.test(t.textContent)) return;
      t.insertAdjacentHTML('afterbegin', '<svg class="sd-desc-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M5 4h14v16H5zM8 8h8M8 12h8M8 16h5"/></svg>');
    });
  }
  /* v74: review cards without broken photos or stray spaces before the closing quote */
  function revClean() {
    document.querySelectorAll('#vstar-reviews .resource-item img').forEach(function (img) {
      var item = img.closest('.resource-item');
      if (img.complete && img.naturalWidth === 0) { item.style.display = 'none'; return; }
      if (!img.dataset.sdErr) { img.dataset.sdErr = '1'; img.addEventListener('error', function () { item.style.display = 'none'; }); }
    });
    document.querySelectorAll('#vstar-reviews .reviews-text').forEach(function (t) {
      if (t.children.length || t.dataset.sdTrim) return;
      t.dataset.sdTrim = '1'; t.textContent = t.textContent.trim();
    });
  }
  function run() {
    rows(); descIcon(); revClean();
    document.querySelectorAll('.shopify-section--main-product .product-title, product-sticky-bar .product-title').forEach(italicLast);
    var main = document.querySelector('.shopify-section--main-product');
    if (!main) return;
    var n = 0;
    for (var sec = main.nextElementSibling; sec; sec = sec.nextElementSibling) {
      if (!sec.classList || !sec.classList.contains('shopify-section') || sec.offsetHeight === 0) continue;
      if (sec.className.indexOf('shopify-section-group-') !== -1) continue;
      var numEl = null;
      if (sec.classList.contains('shopify-section--apps')) {
        if (!sec.querySelector('[class*="trustoo"], [class*="tt-"]')) continue;
        if (sec.classList.contains('sd-rev-empty') || /no reviews yet/i.test(sec.innerText || '')) {
          /* v74: no reviews yet -> one numbered line and a button (canvas r13, option 0) */
          var old = sec.querySelector(':scope > .sdp-rev-head'); if (old) old.remove();
          var line = sec.querySelector(':scope > .sd-rev-emptyline');
          if (!line) {
            sec.classList.add('sd-rev-empty');
            var pt = document.querySelector('.shopify-section--main-product .product-title');
            line = document.createElement('div'); line.className = 'sd-rev-emptyline';
            line.innerHTML = '<div><div><h2 class="sdp-h2"><span class="sdp-num"></span><span class="sd-rev-empty-t"></span></h2><p>Bought one? Tell other buyers how it looks at home.</p></div><button type="button">Write the first review</button></div>';
            line.querySelector('.sd-rev-empty-t').textContent = 'No reviews yet for ' + (pt ? pt.textContent.trim() : 'this piece') + '.';
            line.querySelector('button').addEventListener('click', function () { var b = sec.querySelector('.tt-write-reviews'); if (b) b.click(); });
            sec.insertBefore(line, sec.firstChild);
          }
          if (numEl === null) numEl = line.querySelector('.sdp-num');
          if (numEl) { numEl.textContent = ROMAN[n] || ''; n++; }
          continue;
        }
        sec.querySelectorAll('[class*="tt-"] *').forEach(function (el) { if (!el.children.length && /^\s*customer reviews\s*$/i.test(el.textContent)) el.style.display = 'none'; });
        var head = sec.querySelector(':scope > .sdp-rev-head');
        if (!head) {
          head = document.createElement('div'); head.className = 'sdp-rev-head';
          head.innerHTML = '<div class="sdp-hwrap"><h2 class="sdp-h2"><span class="sdp-num"></span><span class="sdp-rev-title">Customer <i>reviews</i></span></h2></div>';
          sec.insertBefore(head, sec.firstChild);
        }
        /* v74 (canvas r13, option 1): one title, the score stays in the summary; "Read all" link on the right */
        head.querySelector('.sdp-rev-title').innerHTML = 'What owners <i>say</i>';
        var more = sec.querySelector('.sd-rev-more'), all = head.querySelector('.sdp-rev-all');
        if (more && !all) {
          all = document.createElement('button'); all.type = 'button'; all.className = 'sdp-rev-all';
          all.textContent = more.textContent;
          all.addEventListener('click', function () { var b = sec.querySelector('.sd-rev-more'); if (b) b.click(); all.remove(); });
          head.querySelector('.sdp-hwrap').appendChild(all);
        }
        numEl = head.querySelector('.sdp-num');
      } else {
        var h = sec.querySelector('h2');
        if (!h) continue;
        if (!h.dataset.sdNum) {
          italicLast(h);
          var num = document.createElement('span'); num.className = 'sdp-num';
          h.insertBefore(num, h.firstChild);
          h.classList.add('sdp-h2'); h.dataset.sdNum = '1';
          if (h.parentElement) h.parentElement.classList.add('sdp-hwrap');
        }
        numEl = h.querySelector('.sdp-num');
      }
      if (numEl) { numEl.textContent = ROMAN[n] || ''; n++; }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  [600, 2000, 4500, 8000].forEach(function (t) { setTimeout(run, t); });
  window.addEventListener('load', function () { setTimeout(run, 300); });
})();

/* 2026-10-19 — cart drawer: "Pairs well with" (two related lights, add in one click) and hide the 10% OFF tab while the cart is open */
(function () {
  function money(cents) { return '£' + (cents / 100).toFixed(2); }
  function fillPairs(drawer) {
    var box = drawer && drawer.querySelector('.sd-cart-pairs');
    if (!box || box.dataset.done) return;
    box.dataset.done = '1';
    var id = box.dataset.productId, inCart = (box.dataset.inCart || '').split(',');
    if (!id) return;
    fetch('/recommendations/products.json?product_id=' + id + '&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data.products || []).filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1; }).slice(0, 2);
        if (!list.length) return;
        var html = '<p class="sd-cart-lab">Pairs well with</p><div class="sd-cart-pairs__grid">';
        list.forEach(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
          html += '<div class="sd-cart-pairs__item">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
            '<span><a class="sd-cart-pairs__name" href="' + p.url + '">' + p.title + '</a>' + (p.price_varies ? 'From ' : '') + money(p.price_min || p.price) +
            (v ? ' · <button type="button" class="sd-cart-pairs__add" data-variant="' + v.id + '">Add</button>' : '') + '</span></div>';
        });
        box.innerHTML = html + '</div>';
        box.hidden = false;
        box.querySelectorAll('.sd-cart-pairs__add').forEach(function (b) {
          b.addEventListener('click', function () {
            b.textContent = 'Adding…';
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.variant), quantity: 1 }] }) })
              .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
          });
        });
      }).catch(function () {});
  }
  var hidden = [];
  function teaser(open) {
    if (open) {
      document.querySelectorAll('div, button, span, strong').forEach(function (el) {
        if (el.children.length || !/^\s*10% OFF\s*$/i.test(el.textContent)) return;
        var c = el;
        while (c && c !== document.body && getComputedStyle(c).position !== 'fixed') c = c.parentElement;
        if (c && c !== document.body && hidden.indexOf(c) === -1) { c.dataset.sdDisp = c.style.display || ''; c.style.setProperty('display', 'none', 'important'); hidden.push(c); }
      });
    } else {
      hidden.forEach(function (c) { c.style.removeProperty('display'); if (c.dataset.sdDisp) c.style.display = c.dataset.sdDisp; }); hidden = [];
    }
  }
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    fillPairs(d);
    /* v75: also a body class, so the Klaviyo teaser (its text sits in tags the loop above misses) is hidden by CSS */
    new MutationObserver(function () { fillPairs(d); teaser(d.hasAttribute('open')); document.body.classList.toggle('sd-cart-open', d.hasAttribute('open')); }).observe(d, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
    teaser(d.hasAttribute('open')); document.body.classList.toggle('sd-cart-open', d.hasAttribute('open'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* v75 — payment logos: the same SVG is printed several times (buy box, hidden block, footer) with the same gradient ids,
   so a logo could take its colours from a hidden copy and show grey (Cartes Bancaires). Give every copy its own ids. */
(function () {
  var n = 0;
  function fix() {
    document.querySelectorAll('svg[aria-labelledby^="pi-"]').forEach(function (svg) {
      if (svg.dataset.sdIds) return;
      svg.dataset.sdIds = '1';
      var k = ++n;
      svg.querySelectorAll('[id]').forEach(function (el) {
        var old = el.id, nu = old + '-sd' + k;
        el.id = nu;
        svg.querySelectorAll('[fill="url(#' + old + ')"]').forEach(function (r) { r.setAttribute('fill', 'url(#' + nu + ')'); });
        svg.querySelectorAll('[stroke="url(#' + old + ')"]').forEach(function (r) { r.setAttribute('stroke', 'url(#' + nu + ')'); });
        if (svg.getAttribute('aria-labelledby') === old) svg.setAttribute('aria-labelledby', nu);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  [1500, 5000].forEach(function (t) { setTimeout(fix, t); });
  document.addEventListener('cart:refresh', function () { setTimeout(fix, 600); });
})();

/* v75 — products with no review of their own (57 of 86): show real Selden reviews of other lights, each labelled with its
   light, in the same card design, plus a 5-star line at the top with the real average of those reviews. Nothing is
   presented as a review of this product. */
(function () {
  if (!document.body || !document.body.classList.contains('sd-tpl-product')) return;
  var SHOP = 97949286724;
  var SOURCES = [ ['15646529487172', 'The Kiln Pendant', '/products/the-kiln-hand-painted-ceramic-pendant'],
                  ['15622867910980', 'The Ridge Pendant', '/products/the-ridge-ribbed-wood-pendant'],
                  ['15646529323332', 'The Halo Wall Light', '/products/the-halo-aluminium-wall-light'] ];
  function api(id, n) { return 'https://api.trustoo.io/api/v1/reviews/get_product_reviews?shop_id=' + SHOP + '&limit=' + n + '&page=1&sort_by=comprehensive-descending&product_id=' + id; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  var meta = document.querySelector('#seal_product');
  var pid = null;
  try { pid = JSON.parse(meta.textContent).id; } catch (e) { var st = document.querySelector('[data-sd-stars-pid]'); if (st) pid = st.getAttribute('data-sd-stars-pid'); }
  if (!pid) return;
  fetch(api(pid, 1)).then(function (r) { return r.json(); }).then(function (j) {
    if (j && j.data && j.data.page && j.data.page.count > 0) return;
    return Promise.all(SOURCES.map(function (s) { return fetch(api(s[0], 100)).then(function (r) { return r.json(); }).then(function (x) { return { src: s, list: (x.data && x.data.list) || [] }; }); }))
      .then(function (sets) {
        var all = [], picks = [], seen = {};
        sets.forEach(function (set) { set.list.forEach(function (r) { all.push(r.star); }); });
        sets.forEach(function (set) {
          var r = set.list.filter(function (x) { var t = (x.content || '').trim(); return x.star === 5 && t.length >= 40 && t.length <= 230 && !seen[x.author]; })[0];
          if (r) { seen[r.author] = 1; picks.push({ r: r, src: set.src }); }
        });
        if (!all.length || !picks.length) return;
        var avg = all.reduce(function (a, b) { return a + b; }, 0) / all.length, n = all.length;
        var avgTxt = (Math.floor(avg * 10) / 10).toFixed(1);
        /* 1. the 5-star line above the title */
        var top = document.querySelector('.shopify-section--main-product .sd-stars');
        if (top) {
          var c = top.querySelector('.sd-stars__count');
          if (c) c.textContent = avgTxt + ' from ' + n + ' Selden reviews';
          top.setAttribute('href', '#sd-rev-fb'); top.setAttribute('aria-label', 'Selden lights are rated ' + avgTxt + ' out of 5 in ' + n + ' reviews. See them');
          top.removeAttribute('hidden'); top.classList.add('sd-stars--shop');
        }
        /* 2. the reviews block, in place of the "no reviews yet" line */
        function build() {
          var line = document.querySelector('.sd-rev-emptyline');
          if (!line) return false;
          if (line.querySelector('.sd-rev-fb')) return true;
          var name = (document.querySelector('.shopify-section--main-product .product-title') || {}).textContent || 'this light';
          var cards = picks.map(function (p) {
            return '<div class="sd-rev-fb__card"><span class="sd-rev-fb__stars" aria-label="5 out of 5">★★★★★</span><p>“' + esc(p.r.content.trim()) + '”</p><span class="sd-rev-fb__who">' + esc(p.r.author.trim()) + ' · <a href="' + p.src[2] + '">' + esc(p.src[1]) + '</a></span></div>';
          }).join('');
          var t = line.querySelector('.sd-rev-empty-t'); if (t) t.innerHTML = 'What owners <i>say</i>';
          var sub = line.querySelector('p'); if (sub) sub.textContent = 'No reviews for ' + name.trim() + ' yet. Here is what owners say about their other Selden lights: ' + avgTxt + ' out of 5 from ' + n + ' reviews.';
          var btn = line.querySelector('button'); if (btn) btn.textContent = 'Write the first review';
          line.id = 'sd-rev-fb';
          line.firstElementChild.insertAdjacentHTML('afterend', '<div class="sd-rev-fb">' + cards + '</div>');
          return true;
        }
        var tries = 0; (function poll() { if (build() || ++tries > 30) return; setTimeout(poll, 400); })();
      });
  }).catch(function () {});
})();
